import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { showNetworkError } from 'platform-components';
import { all, delay, put, select, take, takeLatest } from 'redux-saga/effects';

import { actions as lessonActions } from 'common.components/lesson';
import * as lessonSelectors from 'common.components/lesson/selectors';
import * as resultsSelectors from 'common.components/results/selectors';

import { resultsActions } from './actions';

const MIN_STATS_DELAY = 10000;
const MAX_STATS_DELAY = 30000;

export function* resultsSagasWatcher() {
    yield all([takeLatest(resultsActions.updateLessonStats, updateLessonStatsSaga)]);
}

export function* updateLessonStatsSaga() {
    try {
        const studentsOnline: Record<number, number | null> = yield select(resultsSelectors.getStudentsOnline);

        if (Object.values(studentsOnline).filter(Boolean).length > 0) {
            const ms = MIN_STATS_DELAY + Math.round(Math.random() * (MAX_STATS_DELAY - MIN_STATS_DELAY));
            yield delay(ms);

            const clessonId: number | null = yield select(lessonSelectors.getCLessonId);
            const courseId: number = yield select(lessonSelectors.getLessonCourseId);
            const status: LESSON_STATUS | null = yield select(lessonSelectors.getLessonStatus);
            const shouldUpdateLessonStats = clessonId && status === LESSON_STATUS.IN_PROGRESS;

            if (shouldUpdateLessonStats) {
                yield put(lessonActions.getClessonResultsRequest({ cLessonId: clessonId, courseId }));
            }

            yield put(resultsActions.updateLessonStats());
        } else {
            yield take(resultsActions.setStudentOnline);
            yield put(resultsActions.updateLessonStats());
        }
    } catch (error) {
        console.error(error);
        yield put(showNetworkError(error));
    }
}
